(() => {
  const dataElement = document.querySelector('[data-no86-product-subscription]');
  if (!dataElement || dataElement.dataset.initialized) return;
  dataElement.dataset.initialized = 'true';
  const data = JSON.parse(dataElement.textContent);
  if (window.RS?.Config) {
    window.RS.Config.subscriptionOptionSelectedByDefault = true;
    window.RS.Config.tooltipDescriptionOnMultipleDiscount = data.tooltip;
  }
  const root = document.getElementById(`MainProduct-${data.sectionId}`);
  if (!root) return;
  const formatter = new Intl.NumberFormat(data.locale || 'en', { style: 'currency', currency: data.currency || 'USD' });
  let pending = false;
  const update = () => {
    pending = false;
    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    if (!form) return;
    const variantId = form.querySelector('[name="id"]')?.value;
    const variant = data.variants.find(item => String(item.id) === String(variantId));
    const selected = form.querySelector('input[name="selling_plan"]:checked');
    const planId = selected?.value || selected?.dataset.appstleRealValue;
    const plan = selected && selected.id.includes('selling_plan_label_2')
      ? variant?.plans.find(item => String(item.id) === String(planId)) : null;
    let terms = form.querySelector('.no86-product-recurring');
    if (!plan) {
      if (terms) terms.remove();
      return;
    }
    const quantityInput = root.querySelector('[name="quantity"]');
    const quantity = Math.max(1, Number(quantityInput?.value) || 1);
    const text = data.terms.replace('[price]', formatter.format(plan.price * quantity / 100)).replace('[frequency]', plan.name.toLowerCase());
    if (!terms) {
      terms = document.createElement('div');
      terms.className = 'no86-product-recurring';
      terms.setAttribute('aria-live', 'polite');
      const bold = document.createElement('strong');
      const renewal = document.createElement('small');
      renewal.textContent = data.autoRenews;
      const shipping = document.createElement('small');
      shipping.textContent = data.shipping;
      terms.append(bold, renewal, shipping);
      const buttons = form.querySelector('.product-form__buttons');
      if (!buttons) return;
      buttons.before(terms);
    }
    if (terms.firstElementChild.textContent !== text) terms.firstElementChild.textContent = text;
  };
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(update);
  };
  root.addEventListener('change', schedule);
  root.addEventListener('input', schedule);
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'checked'] });
  window.addEventListener('pageshow', schedule);
  schedule();
})();
